import React from 'react'
// import VotedItem from './votedItem'

const ListVoted = () => {
  return (
    <div className='animate-fade-in-down'>
      {/* <VotedItem /> */}
      <div className=' flex justify-center items-center text-$gray'>
        ยังไม่มีรายการที่สนใจ
      </div>
    </div>
  )
}

export default ListVoted